<template>
<div class="atlas">
  <div ref="map" class="map"></div>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

mapboxgl.accessToken = process.env.MAPBOX_KEY

export default Vue.component('Atlas', {
  props: ['artists'],
  data: () => ({
    map: null
  }),
  methods: {
    handleKeyDown(event) {
      if(event.key === 'Meta') this.map.scrollZoom.enable()
    },
    handleKeyUp(event) {
      if(event.key === 'Meta') this.map.scrollZoom.disable()
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
    this.map = new mapboxgl.Map({
      container: this.$refs.map,
      style: 'mapbox://styles/mapbox/light-v9',
      zoom: 1.6,
      center: [39.43060748814355, 8.091039810137929],
      attributionControl: false
    })

    this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')
    this.map.addControl(new mapboxgl.AttributionControl({ compact: true }))

    this.map.scrollZoom.disable()

    this.map.on('load', () => {
      this.artists.forEach(artist => {
        const marker = document.createElement('div')
        marker.classList.add('atlas-marker')

        if(artist.hidden) marker.classList.add('atlas-marker--hidden')
        if(artist.current) marker.classList.add('atlas-marker--current')

        marker.addEventListener('click', event => {
          event.preventDefault()
          this.$router.push(`/atlas/artist/${artist.slug}`)
        })

        const num = document.createElement('span')
        num.innerText = artist.num

        marker.appendChild(num)

        const label = document.createElement('div')
        label.classList.add('atlas-marker__label')
        label.innerText = artist.title

        marker.appendChild(label)

        new mapboxgl.Marker(marker)
          .setLngLat(artist.coords.split(','))
          .addTo(this.map)
      })
    })
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.atlas {
  background: $color-white;
  overflow: hidden;
}
.map {
  height: calc(100vh - 8rem);
  @media (max-width: $break-small) {
    height: 100vh;
  }
}
</style>

<style lang="scss">
@import '~@/_variables.scss';

.atlas-marker {
  width: 1.9rem;
  height: 1.9rem;
  background: $color-red;
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
  user-select: none;
  &:hover {
    .atlas-marker__label {
      visibility: visible;
    }
  }
  &--hidden {
    background: $color-gray;
    pointer-events: none;
    .atlas-marker__label {
      background: $color-gray;
    }
  }
  &--current {
    background: $color-blue;
    span {
      color: $color-white;
    }
    .atlas-marker__label {
      background: $color-blue;
      color: $color-white;
    }
  }
  span {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1rem;
    font-weight: bold;
    line-height: 1;
    margin-top: -0.05rem;
  }
  &__label {
    visibility: hidden;
    position: absolute;
    top: 0; right: 0;
    height: 100%;
    white-space: nowrap;
    transform: translateX(99.9%);
    font-family: $font-mono;
    font-weight: normal;
    text-transform: uppercase;
    line-height: 1;
    background: $color-red;
    padding: 0 0.75rem;
    padding-top: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atlas.vue